import React from 'react'
import clsx from 'clsx'

interface DashboardSectionProps {
  title: string
  description?: string
  /** Short tag such as "posição atual", to flag blocks that ignore the period filter */
  badge?: string
  actions?: React.ReactNode
  className?: string
  children: React.ReactNode
}

const DashboardSection: React.FC<DashboardSectionProps> = ({
  title,
  description,
  badge,
  actions,
  className,
  children,
}) => {
  return (
    <section className={clsx('w-full flex flex-col gap-4', className)}>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <h2 className="text-[17px] font-semibold tracking-tight text-foreground">{title}</h2>
            {badge && (
              <span className="rounded-full border border-border bg-card-muted px-2.5 py-0.5 text-[12px] font-medium text-muted-foreground">
                {badge}
              </span>
            )}
          </div>
          {description && (
            <p className="text-[13px] leading-snug text-muted-foreground">{description}</p>
          )}
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
      {children}
    </section>
  )
}

export default DashboardSection
